/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Free_UnitInputs */

const en_mk_price_free_unit = /** @type {(inputs: Mk_Price_Free_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`up to 3 members`)
};

const id_mk_price_free_unit = /** @type {(inputs: Mk_Price_Free_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sampai 3 anggota`)
};

/**
* | output |
* | --- |
* | "up to 3 members" |
*
* @param {Mk_Price_Free_UnitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_free_unit = /** @type {((inputs?: Mk_Price_Free_UnitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Free_UnitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_free_unit(inputs)
	return en_mk_price_free_unit(inputs)
});